import { HttpAction } from "@megaron/http-service";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

export const mentionSerializer = Serializers.object({
  user: Serializers.string,
  tagPosition: Serializers.integer,
  tagLength: Serializers.integer,
});

export type Mention = SerializerValue<typeof mentionSerializer>;

export const commentResourceTypes = ["supportTicket", "crmCustomer"] as const;
export type CommentResourceType = (typeof commentResourceTypes)[number];

export const commentSerializer = Serializers.object({
  id: uuidSerializer,
  resourceType: Serializers.stringOneOf(...commentResourceTypes),
  resourceId: Serializers.string,
  body: Serializers.string,
  authorEmail: Serializers.string.optional(),
  mentions: mentionSerializer.array(),
  createdAt: Serializers.datetime,
});

export type CommentDto = SerializerValue<typeof commentSerializer>;

export const commentsActions = {
  commentsByResource: HttpAction({
    path: "/comments",
    method: "get",
    qsSerializer: Serializers.object({
      resourceType: Serializers.stringOneOf(...commentResourceTypes),
      resourceId: Serializers.string,
    }),
    valueSerializer: commentSerializer.array(),
    requiresAuth: true,
  }),

  createComment: HttpAction({
    path: "/comments",
    method: "post",
    bodySerializer: Serializers.object({
      resourceType: Serializers.stringOneOf(...commentResourceTypes),
      resourceId: Serializers.string,
      body: Serializers.string,
      mentions: mentionSerializer.array().optional(),
    }),
    valueSerializer: commentSerializer,
    requiresAuth: true,
  }),
};
